document.addEventListener('DOMContentLoaded', () => {
	const roots = document.querySelectorAll('[data-links-anim-root]');
	if (!roots.length) return;

	const isDesktop = () => window.matchMedia('(min-width: 1001px)').matches;

	roots.forEach((root) => {
		const svg = root.querySelector('[data-links-anim-svg]');
		const links = Array.from(root.querySelectorAll('[data-links-anim-link]'));

		if (!svg || !links.length) return;

		let currentIndex = 0;

		const clearActive = () => {
			links.forEach((link) => link.classList.remove('is-active'));
		};

		const setActive = (index) => {
			clearActive();
			if (!links[index]) return;
			links[index].classList.add('is-active');
			currentIndex = index;
		};

		const moveSvgToLink = (index) => {
			if (!isDesktop()) {
				svg.style.transform = 'translateY(0px)';
				return;
			}

			const firstLink = links[0];
			const targetLink = links[index];

			if (!firstLink || !targetLink) return;

			const firstRect = firstLink.getBoundingClientRect();
			const targetRect = targetLink.getBoundingClientRect();

			const offset = targetRect.top - firstRect.top;
			svg.style.transform = `translateY(${offset}px)`;
		};

		const resetToDefault = () => {
			setActive(0);
			moveSvgToLink(0);
		};

		resetToDefault();

		links.forEach((link, index) => {
			link.addEventListener('mouseenter', () => {
				if (!isDesktop()) return;
				setActive(index);
				moveSvgToLink(index);
			});

			link.addEventListener('focus', () => {
				if (!isDesktop()) return;
				setActive(index);
				moveSvgToLink(index);
			});
		});

		root.addEventListener('mouseleave', () => {
			if (!isDesktop()) return;
			resetToDefault();
		});

		window.addEventListener('resize', () => {
			if (!isDesktop()) {
				clearActive();
				if (links[0]) {
					links[0].classList.add('is-active');
				}
				svg.style.transform = 'translateY(0px)';
				return;
			}

			moveSvgToLink(currentIndex);
		});
	});
});